<tax-modal-header>address.modal.title</tax-modal-header>

<tax-modal-content>
  <form [formGroup]="newAddress" (ngSubmit)="submit(newAddress.value)">
    <div class="search-input">
      <tax-input
        formControlName="searchText"
        id="searchText"
        (keydown.enter)="getToponym()"
        placeholder="address.modal.toponym.title"
        [autofocus]="true"
        [tabindex]="1"
        [clearable]="true"
        (cleanEvent)="clearInput()"
        [autocomplete]="false"
        prefix="search"
      ></tax-input>

      <button
        class="button_blue"
        type="button"
        data-qa="search-button"
        (click)="getToponym()"
        translate
      >
        address.modal.search
      </button>
    </div>

    <div class="address_body">
      <div class="addresses" taxScrollbar *ngIf="addresses.length">
        <span
          *ngFor="let address of addresses; trackBy: trackByFn"
          (click)="selectAddress(address)"
          >{{ address.path }}</span
        >
      </div>
      <div class="empty_address_block" *ngIf="!addresses.length">
        <span translate>address.modal.enter.text</span>
      </div>
    </div>

    <div class="address">
      <tax-input
        class="input-field"
        [required]="true"
        [labelText]="'address.modal.toponym'"
        [id]="'locality'"
        [disabled]="true"
        formControlName="currentAddress"
        [tabindex]="2"
      ></tax-input>

      <tax-input
        class="input-field"
        [required]="true"
        [labelText]="'address.modal.street'"
        [id]="'street'"
        formControlName="street"
        placeholder="address.modal.street.example"
        [tabindex]="3"
      ></tax-input>

      <div class="address_horizontal_block">
        <tax-input
          class="input-field"
          [required]="true"
          [labelText]="'address.modal.house'"
          [id]="'house'"
          formControlName="house"
          placeholder="55"
          [tabindex]="3"
        ></tax-input>

        <tax-input
          class="input-field"
          [labelText]="'address.modal.building'"
          [id]="'housing'"
          formControlName="housing"
          placeholder="13"
          [tabindex]="4"
        ></tax-input>

        <tax-input
          class="input-field"
          [labelText]="'address.modal.apartment'"
          [id]="'apartment'"
          formControlName="apartment"
          placeholder="21"
          [tabindex]="5"
        ></tax-input>
      </div>
    </div>
  </form>
</tax-modal-content>

<tax-modal-footer>
  <button
    class="button_blue ui-kit-align-right"
    data-qa="send-button"
    [disabled]="newAddress.invalid"
    translate
    (click)="submit(newAddress.value)"
  >
    modal.select
  </button>
</tax-modal-footer>
